import Lenis from 'lenis';

let lenis = null;

const prefersReducedMotion = () =>
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

export function getLenis() {
    return lenis;
}

export function initLenis() {
    if (lenis) {
        return lenis;
    }

    if (prefersReducedMotion()) {
        return null;
    }

    lenis = new Lenis({
        autoRaf: true,
        allowNestedScroll: true,
        stopInertiaOnNavigate: true,
        anchors: { offset: 80 },
    });

    return lenis;
}

/**
 * Przewija do elementu z uwzględnieniem sticky headera.
 *
 * @param {HTMLElement} element
 * @param {number} headerOffset — odstęp od góry viewportu (px), ten sam co wcześniej w scrollTo
 */
export function scrollToElement(element, headerOffset = 0) {
    const instance = getLenis();

    if (instance) {
        instance.scrollTo(element, { offset: -headerOffset });
        return;
    }

    const top =
        element.getBoundingClientRect().top + window.scrollY - headerOffset;

    window.scrollTo({
        top: Math.max(0, top),
        behavior: prefersReducedMotion() ? 'auto' : 'smooth',
    });
}
